<template>
  <van-popup v-model="visible" position="center" closeable round>
    <div class="InputPopup">
      <div class="title">{{ title }}</div>
      <div class="content">
        <van-field v-model="value" :type="type" :placeholder="placeholder" :rows="rows" />
      </div>
      <div class="footer">
        <div class="cancel" @click="onCancel">取消</div>
        <div class="confirm" @click="onConfirm">确定</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'InputPopup',
  data() {
    return {
      visible: false,
      title: '',
      placeholder: '',
      value: '',
      type: 'text',
      rows: 1
    }
  },
  methods: {
    show({ title = '', placeholder = '', value = '', type = 'text', rows = 1 }) {
      return new Promise((resolve, reject) => {
        this.visible = true
        this.resolve = resolve
        this.reject = reject
        this.title = title
        this.value = value
        this.placeholder = placeholder
        this.type = type
        this.rows = rows
        console.log(this.type, this.rows)
      })
    },
    onCancel() {
      this.visible = false
      this.reject()
    },
    onConfirm() {
      this.resolve(this.value)
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.InputPopup {
  width: 280px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;

  .title {
    padding: 16px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    text-align: center;
    border-bottom: 1px solid #f5f5f5;
  }

  .content {
    padding: 20px 16px;

    input {
      width: 100%;
      height: 40px;
      padding: 0 12px;
      border: 1px solid #e5e5e5;
      border-radius: 6px;
      font-size: 14px;
      color: #333;

      &:focus {
        border-color: #1989fa;
        outline: none;
      }
    }
  }

  .footer {
    display: flex;
    border-top: 1px solid #f5f5f5;

    .cancel,
    .confirm {
      flex: 1;
      height: 44px;
      line-height: 44px;
      text-align: center;
      font-size: 15px;
      cursor: pointer;
      transition: background-color 0.2s;
    }

    .cancel {
      color: #666;
      border-right: 1px solid #f5f5f5;

      &:active {
        background-color: #f5f5f5;
      }
    }

    .confirm {
      color: #1989fa;

      &:active {
        background-color: #f0f9ff;
      }
    }
  }
}

:deep(.van-popup) {
  border-radius: 12px;
  overflow: hidden;
}
</style>
